import { render, staticRenderFns } from "./IconLinkBox.vue?vue&type=template&id=2b22d540&scoped=true"
import script from "./IconLinkBox.vue?vue&type=script&lang=js"
export * from "./IconLinkBox.vue?vue&type=script&lang=js"
import style0 from "./IconLinkBox.vue?vue&type=style&index=0&id=2b22d540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22d540",
  null
  
)

export default component.exports